(function() {
  app.filter('rabonaLinebreaks', function(){
    return function( text ) {
      if (text) {
        return text.replaceAll("\\n","\n");
      }
    };
  });
})();
